import { call, put } from 'redux-saga/effects';

import { takeLatest } from '../../../utils/reduxSaga';
import { actions as sagaActions, UPDATE_SETTINGS } from './types';
import { actions as loaderReduxActions } from '../../../partials/loader/reducers';
import { URLS } from '../../../consts/endpoints';
import RESPONSE_CODES from '../../../consts/responseCodes';
import { postData, updateData } from '../../../utils/http';
import mapSettingsToUpdate from './mapSettingsToUpdate';
import showSnackbar from '../../../utils/showSnackbar';
import { getSettings } from './getSettings';

export function updateOnSubmit({ settings, partnerId, isNewPartner }) {
  return {
    type: sagaActions[UPDATE_SETTINGS],
    settings,
    partnerId,
    isNewPartner
  };
}

export function* updateSettings({ settings, partnerId, isNewPartner }) {
  const mappedsSettings = mapSettingsToUpdate({
    settings,
    partnerId,
    isNewPartner
  });

  yield put(loaderReduxActions.startLinearLoader());
  const response = yield call(isNewPartner ? postData : updateData, {
    url: isNewPartner ? URLS.PARTNERS : `${URLS.PARTNERS}/${partnerId}.json`,
    data: mappedsSettings
  });

  if (response.status === RESPONSE_CODES.SUCCESS) {
    yield call(showSnackbar, {
      intlTextKey: 'MESSAGE.UPDATE.SETTINGS',
      messageType: 'success'
    });

    yield call(getSettings, { partnerId });
  }

  yield put(loaderReduxActions.stopLinearLoader());
}

function* watchUpdateAppSettings() {
  yield takeLatest(sagaActions[UPDATE_SETTINGS], updateSettings);
}

export default watchUpdateAppSettings();
